module.exports = __webpack_public_path__ + "img/rolling-on-the-floor-laughing.5de5e150.png";